"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
const react_1 = require("react");
const useAuthTokens_1 = require("./useAuthTokens");
const useActiveLau_1 = require("./useActiveLau");
const useUser_1 = require("./useUser");
const AuthProvider_1 = require("../providers/AuthProvider");
const useAuth = () => {
    const [isAuthenticating, setIsAuthenticating] = (0, react_1.useState)(true);
    const { activeLau, unsetActiveLau, setActiveLau } = (0, useActiveLau_1.useActiveLau)();
    const { user, setUser } = (0, useUser_1.useUser)();
    const { isLogged, saveAuthTokens } = (0, useAuthTokens_1.useAuthTokens)();
    const dispatch = (0, AuthProvider_1.useAuthDispatch)();
    (0, react_1.useEffect)(() => {
        setIsAuthenticating(false);
    }, []);
    const logout = () => {
        saveAuthTokens(undefined);
        setUser(undefined);
        dispatch(AuthProvider_1.AuthAction.logout(undefined));
        unsetActiveLau();
    };
    return {
        user,
        activeLau,
        isLogged,
        logout,
        setActiveLau,
        isAuthenticating,
    };
};
exports.useAuth = useAuth;
